/**
 * Shared Temperature Attribute Configuration
 * Always IoT-enabled with centralized source
 */

import * as gqlTypes from "@hydrologiq/gql/graphql"
import type { AttributeConfig } from "../../types"
import { validateTemperature as sharedValidateTemperature } from "../validators"
import { temperatureIoTSource } from "../iot-sources"

export { validateTemperature } from "../validators"

export const baseTemperatureConfig: Partial<AttributeConfig> = {
  attribute: gqlTypes.ActivityAttributeKind.Temperature,
  label: "Temperature (°C)",
  validator: sharedValidateTemperature,
  order: 30,
  iotSource: temperatureIoTSource(), // Always use IoT source
}

export const temperatureForStarted = (): AttributeConfig =>
  ({
    ...baseTemperatureConfig,
    visibility: "iot",
    editable: true,
    required: false,
    helpText: `Temperature at start (from IoT sensor or manual entry, used to calculate hydrogen level with pressure and volume)`,
  } as AttributeConfig)

export const temperatureForCompleted = (): AttributeConfig =>
  ({
    ...baseTemperatureConfig,
    visibility: "iot",
    editable: true,
    required: false,
    helpText: `Temperature at completion (from IoT sensor or manual entry, used to calculate final hydrogen level)`,
  } as AttributeConfig)

export const temperatureHidden: AttributeConfig = {
  ...baseTemperatureConfig,
  visibility: "hidden",
  editable: false,
  required: false,
} as AttributeConfig
